<ng-container *ngComponentOutlet="activeComponent; inputs: activeComponentInputs"></ng-container>
